import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import './style.css'

class OrderPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      message: '',
      product: '',
      price: '',
      image: ''
    }
    this.emailInputRef = React.createRef()
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search)
    const product = urlParams.get('product') || ''
    this.setState({
      product: product,
      price: urlParams.get('price') || '',
      image: urlParams.get('image') || '',
      message: `Hello,\n\nI would like to order:\n\n${product}`
    }, () => {
      // Focus the email input after state is set
      if (this.emailInputRef.current) {
        this.emailInputRef.current.focus()
      }
    })
  }

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value })
  }

  handleMessageChange = (e) => {
    this.setState({ message: e.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if (!this.state.email) {
      alert('Please enter your email address')
      return
    }

    // Email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(this.state.email)) {
      alert('Please enter a valid email address')
      return
    }

    if (!this.state.message) {
      alert('Please enter a message')
      return
    }

    const form = document.createElement('form')
    form.action = 'https://formspree.io/f/xovnovgj'
    form.method = 'POST'
    form.style.display = 'none'

    const messageInput = document.createElement('input')
    messageInput.type = 'hidden'
    messageInput.name = 'message'
    messageInput.value = this.state.message

    const emailInput = document.createElement('input')
    emailInput.type = 'hidden'
    emailInput.name = '_replyto'
    emailInput.value = this.state.email

    form.appendChild(messageInput)
    form.appendChild(emailInput)

    document.body.appendChild(form)
    form.submit()
  }

  render() {
    const { email, message } = this.state

    return (
      <div className='order-page-container'>
        <div className='order-page-content'>
          <form onSubmit={this.handleSubmit} className='order-page-form'>
            <div className='order-page-form-group'>
              <input
                type='email'
                id='email'
                value={email}
                onChange={this.handleEmailChange}
                placeholder='your email address'
                required
                className='order-page-email-input'
                ref={this.emailInputRef}
              />
            </div>

            <div className='order-page-form-group'>
              <textarea
                id='message'
                value={message}
                onChange={this.handleMessageChange}
                required
                className='order-page-message-textarea'
              />
            </div>

            <button type='submit' className='order-page-submit-button'>
              Send
            </button>
          </form>

          <div className='order-page-back-link'>
            <button onClick={() => this.props.history.goBack()} className='order-page-back-button'>
              ← Back to Available Titles
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(OrderPage)